import { Droplets, MapPin, Phone, MessageCircle, Facebook, BadgeCheck } from "lucide-react";
import { STORE, waLink } from "../data/store";

export const Footer = () => {
  return (
    <footer className="bg-[#0A3977] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2">
            <div className="relative flex items-center justify-center w-9 h-9 rounded-lg bg-white/10">
              <Droplets className="w-5 h-5 text-white" />
            </div>
            <div className="leading-tight">
              <div className="font-display font-extrabold text-lg">{STORE.name}</div>
              <div className="text-[10px] font-bold tracking-widest uppercase text-[#F59E0B]">{STORE.slogan}</div>
            </div>
          </div>
          <p className="mt-3 text-sm text-blue-100 max-w-xs">{STORE.tagline}</p>
          <p className="mt-3 text-sm text-blue-200">
            Pinturas inmobiliarias, automotivas, industriales · Accesorios e insumos para chapería y pintura · Laboratorio de color.
          </p>
        </div>

        <div>
          <div className="font-bold mb-3">Contacto</div>
          <div className="space-y-2 text-sm text-blue-100">
            <div className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5" /> {STORE.address}, {STORE.city}</div>
            <div className="flex items-center gap-2"><Phone className="w-4 h-4" /> {STORE.phoneDisplay}</div>
          </div>
          <div className="mt-4 flex flex-wrap gap-2">
            <a
              href={waLink(`Hola ${STORE.name}!`)} target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#25D366] text-white font-bold text-sm hover:bg-[#1EBE5B] transition-colors"
            >
              <MessageCircle className="w-4 h-4" /> WhatsApp
            </a>
            <a
              data-testid="footer-facebook" href={STORE.facebook} target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1877F2] text-white font-bold text-sm hover:bg-[#0f63d1] transition-colors"
            >
              <Facebook className="w-4 h-4" /> Facebook
            </a>
          </div>
        </div>

        <div>
          <div className="font-bold mb-3">Horario</div>
          <p className="text-sm text-blue-100">{STORE.hours}</p>
          <div className="mt-4 flex flex-wrap gap-2">
            <span className="inline-flex items-center gap-2 pl-3 pr-1.5 py-1 rounded-full bg-[#E02424] text-xs font-semibold">
              <BadgeCheck className="w-3.5 h-3.5" /> Distribuidor autorizado
              <span className="inline-flex items-center bg-white rounded-full px-2 py-0.5"><img src="/brands/sherwin-williams.png" alt="Sherwin-Williams" className="h-4 w-auto" /></span>
            </span>
            <span className="inline-flex items-center gap-2 pl-3 pr-1.5 py-1 rounded-full bg-white/10 text-xs font-semibold">
              Distribuidor <span className="inline-flex items-center bg-white rounded-full px-2 py-0.5"><img src="/brands/killing.png" alt="Killing" className="h-5 w-auto" /></span>
            </span>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-blue-200">
        © {new Date().getFullYear()} {STORE.name} ({STORE.legacyName}) · Hernandarias, Paraguay. Todos los derechos reservados.
      </div>
    </footer>
  );
};
